/**
 * THE menu. Five items, in this order, everywhere a shopper or an owner sees navigation:
 * the header, the tenant site's section index, the back office's Products group and the
 * billboard-button picker all read from here so they can never drift apart.
 */
export const SHOP_NAV = [
    { key: "shirts", label: "Shirts", to: "/shirts", office: "/account/products?tab=shirts",
      short: "Every tee, tank and hoodie in six colors, plus DTF gang sheets." },
    { key: "signs", label: "Signs", to: "/signs", office: "/account/products?tab=signs",
      short: "Banners, rigid signs, vinyl, cards and magnets." },
    { key: "classifieds", label: "Classifieds", to: "/supplies", office: "/account/listings",
      short: "Buy and sell used machines, supplies and blanks." },
    { key: "classes", label: "Classes", to: "/classes", office: "/account/classes",
      short: "Learn to print in a class at the shop." },
    { key: "wholesale", label: "Wholesale", to: "/wholesale", office: "/account/coupons",
      short: "Coupons and bulk prices for repeat customers." },
];

export const NAV_BY_KEY = Object.fromEntries(SHOP_NAV.map((n) => [n.key, n]));

/** Every product promises one of three. The sub-menu under Shirts and Signs is this list. */
export const READY_IN = [
    { key: "same_day", label: "Same Day", short: "today", note: "Order and pay before 2 PM — printed today, ready tonight." },
    { key: "days_3_5", label: "3–5 Days", short: "this week", note: "Printed within the week — pick up or we ship." },
    { key: "weeks_2_4", label: "2–4 Weeks", short: "made to order", note: "Ordered in for you and printed when it lands." },
];
export const READY_BY_KEY = Object.fromEntries(READY_IN.map((r) => [r.key, r]));
export const readyLabel = (key) => READY_BY_KEY[key]?.label || "";

/** The one page under Shirts that is its own thing. */
export const DTF_PAGE = { key: "dtf", label: "DTF Gang Sheet", to: "/shirts/dtf" };

/** Cart, not bags: one word every shopper already knows. */
export const CART_LABEL = "Cart";

/** Phase 10 — the signs365-style top menu. Seven groups, every page, every shop. Wholesale lives in the footer only. */
export const TOP_MENU = [
    { key: "shirts", label: "Shirts", to: "/shirts" },
    { key: "signs", label: "Signs", to: "/signs" },
    { key: "flyers", label: "Flyers", to: "/print" },
    { key: "websites", label: "Websites", to: "/website-design" },
    { key: "artwork", label: "Artwork", to: "/artwork-request" },
    { key: "classifieds", label: "Classifieds", to: "/supplies" },
    { key: "classes", label: "Classes", to: "/classes" },
];

/** The one line on the house site that sells the software: print shops click here to get this site. */
export const PRINT_SHOPS = { key: "print-shops", to: "/whitelabel", label: "Print shops — get this site", short: "Print shops" };
